var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"mask rd-loading",attrs:{"role":"status","aria-label":_vm.$t('lang.Loading')}},[_c('van-loading',{attrs:{"type":"circular","color":"#ff6055","size":"36px"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }